export default __webpack_public_path__ + "static/media/blog.247b3117.jpg";